//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Alvarado",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',
        item8: '0',
      },
      descTxt: ''
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 * 2 + form.item2 + form.item3 + form.item4 + form.item5 + form.item6 + form.item7 + form.item8
        if (result < 5) {
          self.descTxt = '阑尾炎的可能性极低'
        } else if (result < 7) {
          self.descTxt = '有阑尾炎的可能'
        } else {
          self.descTxt = '阑尾炎的可能性极大'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Alvarado.vue